import React, { useEffect } from 'react'
import {useNavigate, Outlet } from 'react-router-dom';
import { USER_TYPE } from '../constants';
import bgurl from '../assets/images/bg.png'


import LayoutWithHeader from './LayoutWithHeader';

function Layout() {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const navigate = useNavigate();

  useEffect(()=>{
    if(!userInfo){
      navigate('/login')
    }
  },[])
  
  return (
   <div style={{padding:'15px', backgroundImage: (userInfo && userInfo.userType === USER_TYPE.USER) ? `url(${bgurl})` : '' }}>
     {userInfo && userInfo.userType === USER_TYPE.CLINICIAN && <LayoutWithHeader />}
     {userInfo && userInfo.userType === USER_TYPE.USER &&  <Outlet />}
   </div>
  )
}

export default Layout